import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'

import * as persisted from '#/state/persisted'

type StateContext = boolean
type SetContext = (v: boolean) => void

const stateContext = createContext<StateContext>(
  Boolean(persisted.defaults.enableSquareAvatars),
)
stateContext.displayName = 'EnableSquareAvatarsStateContext'
const setContext = createContext<SetContext>((_: boolean) => {})
setContext.displayName = 'EnableSquareAvatarsSetContext'

export function Provider({children}: {children: React.ReactNode}) {
  const [state, setState] = useState(
    Boolean(persisted.get('enableSquareAvatars')),
  )

  const setStateWrapped = useCallback(
    (enableSquareAvatars: persisted.Schema['enableSquareAvatars']) => {
      setState(Boolean(enableSquareAvatars))
      void persisted.write('enableSquareAvatars', enableSquareAvatars)
    },
    [setState],
  )

  useEffect(() => {
    return persisted.onUpdate(
      'enableSquareAvatars',
      nextEnableSquareAvatars => {
        setState(Boolean(nextEnableSquareAvatars))
      },
    )
  }, [setStateWrapped])

  return (
    <stateContext.Provider value={state}>
      <setContext.Provider value={setStateWrapped}>
        {children}
      </setContext.Provider>
    </stateContext.Provider>
  )
}

export const useEnableSquareAvatars = () => useContext(stateContext)
export const useSetEnableSquareAvatars = () => useContext(setContext)
